// extracted by mini-css-extract-plugin
export default {"topSection":"styles_topSection__2UiCU","topsection_wrapper":"styles_topsection_wrapper__AUIB6","steps":"styles_steps__QBQx0"};